import {
  Arrow,
  Button,
  CreditCardStyled,
  Disclaimer,
  Div,
  EditPenDarkBlueIcon,
  H2,
  Icon,
  IconButtonStyled,
  P,
  Pill,
  Separator,
  TrashIcon,
  UserRole,
  VPayLogo,
  Wallets,
  displayCentsInDollars,
  lightTheme,
} from '@vgrubs/components';

export const CreditCard = ({
  wallet,
  title,
  userRole,
  handleConnectBank,
  handleTransfer,
  handleDeleteBank,
  handleEditBallance,
  handlePendingTransactions,
}: {
  wallet: Wallets;
  title: string;
  userRole: UserRole;
  handleConnectBank: (wallet: Wallets | null) => void;
  handleTransfer?: (wallet: Wallets) => void;
  handleDeleteBank?: (wallet: Wallets) => void;
  handleEditBallance?: (wallet: Wallets) => void;
  handlePendingTransactions?: (wallet: Wallets) => void;
}) => {
  return (
    <CreditCardStyled>
      <Div $flex $alignCenter $between $gap="24px" $gapSM="16px">
        <Div $desktop>
          <VPayLogo height="90px" width="90px" />
        </Div>
        <Div $mobile>
          <VPayLogo height="75px" width="75px" />
        </Div>
        <Div $flex $column $alignEnd>
          <Div $desktop>
            <P $right $mb="4" $color={lightTheme.white}>
              {title}
            </P>
          </Div>
          <Div $mobile>
            <Disclaimer $right $mb="4" $color={lightTheme.white}>
              {title}
            </Disclaimer>
          </Div>
          <H2 $right $mb="4" $color={lightTheme.white}>
            {displayCentsInDollars(wallet?.balance.availableBalance ?? 0)}
          </H2>
          {userRole === UserRole.partner && (
            <Pill
              $pointer
              $background={`${lightTheme.white}${lightTheme.transparency.t20}`}
              onClick={() => handlePendingTransactions?.(wallet)}
            >
              <Div $p="4px" $flex $alignCenter $gap="8px">
                <P $m="0" $color={lightTheme.white}>
                  Pending{': '}
                  {displayCentsInDollars(wallet?.pendingBalance ?? 0)}
                </P>
                <Icon $size="12" $color={lightTheme.white}>
                  <Arrow />
                </Icon>
              </Div>
            </Pill>
          )}
        </Div>
      </Div>
      <Separator
        // $m="20px 0"
        $color={`${lightTheme.white}${lightTheme.transparency.t50}`}
      />
      <Div $flex $alignCenter $between $gap="24px" $gapSM="16px">
        {wallet?.isBankConnected && handleTransfer && (
          <>
            <Div
              $flex
              $alignCenter
              $gap="12px"
              $gapSM="8px"
              onClick={() => handleConnectBank(wallet)}
              $pointer
            >
              <IconButtonStyled $color={lightTheme.white}>
                <Icon $size="20" $sizeSM="16" color={lightTheme.blue}>
                  <EditPenDarkBlueIcon />
                </Icon>
              </IconButtonStyled>
              <Disclaimer $m="0" $color={lightTheme.white}>
                Bank Account: **{wallet.bankLastFour}
                <br />
                <b>Edit Bank Account</b>
              </Disclaimer>
            </Div>
            <Button
              $selected
              $whiteBlue
              $w={'150px'}
              $wSM={'100px'}
              $smallSM
              onClick={() => handleTransfer(wallet)}
            >
              Transfer
            </Button>
          </>
        )}

        {wallet?.isBankConnected && handleDeleteBank && (
          <Div
            $flex
            $alignCenter
            $gap="12px"
            $gapSM="8px"
            onClick={() => handleDeleteBank(wallet)}
            $pointer
            $width={'100%'}
          >
            <IconButtonStyled $color={lightTheme.primary}>
              <Icon $size="20" $sizeSM="16" color={lightTheme.white}>
                <TrashIcon />
              </Icon>
            </IconButtonStyled>
            <Disclaimer $m="0" $color={lightTheme.white}>
              Bank Account: **{wallet.bankLastFour}
              <br />
              <b>Remove Bank Account</b>
            </Disclaimer>
          </Div>
        )}

        {handleEditBallance && (
          <Button
            $whiteBlue
            $w={wallet.isBankConnected ? '200px' : 'calc(50% - 8px)'}
            $wSM={wallet.isBankConnected ? '100px' : 'calc(50% - 8px)'}
            $smallSM
            onClick={() => handleEditBallance(wallet)}
          >
            Edit Balance
          </Button>
        )}

        {!wallet?.isBankConnected && (
          <Button
            $selected
            $whiteBlue
            $w={'50%'}
            $wSM={'calc(50% - 8px)'}
            $smallSM
            onClick={() => handleConnectBank(wallet)}
          >
            Connect Bank
          </Button>
        )}
      </Div>
    </CreditCardStyled>
  );
};
